















import { Component, Vue, Prop } from 'vue-property-decorator';
import ArticleMeta from '@/components/article/ArticleMeta.vue';
import { Article } from '@/services/articles';

@Component({
  components: {
    ArticleMeta
  }
})
export default class ArticlePreview extends Vue {
  @Prop() article!: Article;
}
